import { Component, OnInit, HostBinding, Input, Output, EventEmitter, Inject } from '@angular/core';
import { TetherDialog } from "../../../common-module/modules/tether-dialog/tether-dialog";

import {  URLSearchParams } from "@angular/http";
import { error } from 'console';

import { PerformanceService } from '../../../../services/performance.service';
import { NotificationService } from '../../../../services/notification.service';

@Component({
  selector: 'app-seat-migration-modal',
  templateUrl: './seat-migration-modal.component.html',
  styleUrls: ['./seat-migration-modal.component.scss'],

})
export class SeatMigrationModalComponent implements OnInit {
  @HostBinding('class.oc-transaction-refund-box') true;
  selectedRoleColor?:string;
  note?:string;

  isLoading: boolean = false;
  combinedPerformanceId:number;
  @Input() performanceId: number;

   combinedPerformances: {text: string, value: any}[];
  
  constructor(    
    private performanceService: PerformanceService,
   private notificationService: NotificationService,
    public tetherDialog: TetherDialog
  ) { }

  ngOnInit() {
    const performanceId = this.performanceId;

    const query = new URLSearchParams();
    query.set('Page', '0');
    query.set('PageSize', '1000');
    query.set('performanceId', performanceId.toString());

this.performanceService.getCombinedPerformances(query).map(res => res.json()).subscribe((combined) => {
    if(combined.Items.length == 0) this.notificationService.add({type: "danger", text: "Listelenecek kombine performansı bulunamadı."})
      
    this.combinedPerformances = combined.Items.map((item) => ({
      text: `${item.PerformanceName} - (${item.PerformanceId})`,
      value: item.PerformanceId,
    }))
},error => console.log(error))
  }

  public onInputChange(e,type){
    switch (type) {
      case 'performance':
        this.combinedPerformanceId = e
        break;
      default:
        break;
    }
  
  }

  public submitClickHandler(){
    this.isLoading = true
    this.performanceService.postCombinedPerformances(this.performanceId, this.combinedPerformanceId).subscribe(res => {
      this.isLoading = false
       this.tetherDialog.close()
       this.notificationService.add({type: "success", text: 'Koltuk taşıma islemi tamamlandi.'});
      
    },error => {
      this.notificationService.add({type: "danger", text: error.Message});
    this.isLoading = false
  })
   
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/boxoffice-module/common/seat-migration-modal/seat-migration-modal.component.ts